import styled from 'styled-components';
// import { Link } from 'react-router-dom';

export const Wrapper_ShadHight = styled.div`
  position: relative;
`;
export const Button = styled.a`
  font-weight: 500;
  display: block;
  color: #fff;
  margin-right: 0.8rem;
  border-radius: 4px;
  background-color: #4e6e29;
  padding: 1.47rem 2.75rem;
  font-size: 1.15rem;
  line-height: 1.6;
  width: 40rem;
  text-align: center;
  width: ${(props) => props.width};
  cursor: pointer;
  border: 1px dashed transparent;
  text-decoration: none;
  transition: all 0.2s ease 0s;
  &:hover {
    background-color: #fff;
    color: #4e6e29;
    border: 1px dashed #4e6e29;
  }
`;
export const Input = styled.input`
  letter-spacing: 1px;
  outline: none;
  display: block;
  width: 75%;
  height: calc(100% - 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.5;
  color: rgb(73, 80, 87);
  background-color: rgb(230, 230, 230);
  background-clip: padding-box;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 0.25rem;
  &:focus {
    background: #fff;
  }
`;
export const TextArea = styled.textarea`
  width: 75%;
  margin: 0.9375em 0px;
  height: 199px;
  font-size: 1.5rem;
  font-weight: 400;
  resize: vertical;
  line-height: 1.5;
  position: relative;
  margin-bottom: 1em;
  padding: 0.375rem 0.75rem;
  outline: none;
  background-color: rgb(230, 230, 230);
  background-clip: padding-box;
  border: 1px solid rgb(230, 230, 230);
  &:focus {
    background: #fff;
  }
`;
export const LabelInputContact = styled.label`
  width: 0;
  height: 0;
  visibility: hidden;
`;
